import React, { type FunctionComponent, forwardRef, useState } from 'react'
import { SearchIcon } from '@instacart/ids-core'
import { useCallback } from 'react'
import { DecoratedInput, type DecoratedInputProps } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { useSelectionManager } from 'utils/selection-manager/SelectionManager'

interface ProductsSearchSearchBoxProps
  extends Omit<DecoratedInputProps, 'onChange' | 'decorationComponent'> {
  onChange: (value: string) => void
}

export const ProductsSearchSearchBox: FunctionComponent<ProductsSearchSearchBoxProps> = forwardRef<
  HTMLInputElement,
  ProductsSearchSearchBoxProps
>(function ProductsSearchInput({ id, onChange, value: initialValue, ...rest }, ref) {
  const [value, setValue] = useState(initialValue as string)

  const messages = useDomainMessages({
    title: 'productsDomain.search.title',
  })
  const { clearSelection } = useSelectionManager()

  const onKeyPress = useCallback(
    evt => {
      if (evt.key !== 'Enter') return

      clearSelection()
      onChange(value)
    },
    [onChange, value, clearSelection]
  )

  return (
    <DecoratedInput
      decorationComponent={SearchIcon}
      decorationPosition={'left'}
      id={id}
      ref={ref}
      data-testid="icon-input-base"
      placeholder={messages.title}
      onChange={evt => setValue(evt.currentTarget.value)}
      onKeyPress={onKeyPress}
      value={value}
      {...rest}
    />
  )
})
